import { z } from 'zod';

export const aiToolDispatchBodySchema = z.object({
  tool_name: z.string().min(1, 'Nome tool obbligatorio').max(200),
  agent_db_id: z.string().uuid('ID agente non valido').optional(),
  tenant_id: z.string().uuid('ID tenant non valido').optional(),
  conversation_id: z.string().max(255).optional(),
  caller_number: z.string().max(50).optional(),
  called_number: z.string().max(50).optional(),
  arguments: z.record(z.unknown()).optional(),
}).passthrough();
export type AiToolDispatchBody = z.infer<typeof aiToolDispatchBodySchema>;

export const aiToolDispatchParamsSchema = z.object({
  tenantId: z.string().uuid('ID tenant non valido'),
  agentDbId: z.string().uuid('ID agente non valido'),
  toolName: z.string().min(1).max(200),
});

// Empty/null preserve the existing value on update; whitespace-only is not a secret.
// Do not enforce a prefix: store the endpoint's exact signing secret, not an API key.
export const aiProviderWebhookSecretSchema = z.string().refine(
  value => value === '' || value.trim().length > 0,
  'Inserisci il segreto dell’endpoint webhook copiato dalla console OpenAI.',
).nullish();

export const aiProviderWebhookSecretRegenerationErrorSchema = z.object({
  success: z.literal(false),
  code: z.literal('WEBHOOK_SECRET_REGENERATION_UNSUPPORTED'),
  error: z.string(),
});
export type AiProviderWebhookSecretRegenerationError = z.infer<typeof aiProviderWebhookSecretRegenerationErrorSchema>;

export const createAiProviderBodySchema = z.object({
  provider_type: z.enum(['openai', 'claude', 'gemini', 'openrouter'], {
    errorMap: () => ({ message: 'Tipo provider non supportato' }),
  }),
  name: z.string().min(1, 'Nome provider obbligatorio').max(255),
  api_key: z.string().min(1, 'API key obbligatoria').max(2048),
  webhook_secret: aiProviderWebhookSecretSchema,
  status: z.enum(['active', 'inactive']).optional(),
  config: z.record(z.unknown()).optional(),
}).passthrough();
export type CreateAiProviderBody = z.infer<typeof createAiProviderBodySchema>;
